export const ASANA_ACCOUNT_LINK_FORM = `https://form.asana.com/?k=YX2IwkgeLAaJS5w6AAknUQ&d=8128188416215`
export const FORMSTACK_LINK = `https://mlse.formstack.com/forms/scoreboard_support_requests`